<template>
<div class="animated fadeIn">
  <b-row>
    <b-col lg="12">
      <CafeteriaRequestsForm/>
    </b-col>
  </b-row>
</div>
</template>
<script>
import CafeteriaRequestsForm from '@/components/modules/cafeteria/requests/alternative1'
export default {
  name: 'CafeteriaRequestsCreate',
  components: {
    CafeteriaRequestsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/requests/create.vue